module.exports = __webpack_public_path__ + "img/purple_silhouette.245e5505.png";